import React from 'react';
import News from '../../../Components/news';

import { DetailNews } from '../../../../assets/img/svg/details';
import { PostInterface } from '../../../Services/types';
interface BlogSectionInterface {
    posts: PostInterface[]
}
const NewsSection: React.FC<BlogSectionInterface> = ({posts}: BlogSectionInterface) => {

    return (
        <section className='pt-8 pb-8 lg:pb-14 xl:pb-28'>
            <div className="px-4">
                <h2 className="text-center text-2xl font-semibold mb-4">Notícias e novidades</h2>

                <div className="relative max-w-screen-xl 2xl:max-w-[1920px] mx-auto">
                    <div className="w-full h-full absolute top-0 left-1/2 -translate-x-1/2 -z-40 hidden lg:flex justify-center mt-20">
                        <DetailNews className='w-full h-full max-w-screen-2xl -translate-x-9' />
                    </div>

                    <div className="bg-white md:py-10 lg:px-10 2xl:px-14 grid md:grid-cols-2 gap-4 rounded-[60px] max-w-[950px] xl:max-w-[1100px] 2xl:max-w-screen-xl mx-auto min-h-[336px]">
                        {posts.slice(0, 2).map((post) => (
                            <News key={post.id} title={post.titulo} excerpt={post.excerpt} date={post.data} slug={post.slug} thumbnail={post.thumbnail}  />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NewsSection;